import type { Address } from '@frontend/api-types';

export const formatAddress = ({ city, line1, line2, postalCode, stateCode }: Address) =>
  `${line1}${line2 ? ` ${line2}` : ''}, ${city}, ${stateCode} ${postalCode}`;
